import {CartaCreditoSidenavFilter} from './sidenav-carta-credito/carta-credito-sidenav.filter';
import {RetificaCartaCreditoSidenavFilter} from './sidenav-carta-credito/retifica-carta-credito-sidenav.filter';
import {EntidadeSelecionadaSidenavFilter} from './sidenav-entidade/entidade-selecionada-sidenav.filter';
import {AuditoriaPadisSidenavFilter} from './sidenavAuditoria/auditoria-empresa-padis-sidenav.filter';
import {AuditoriaEmpresaSidenavFilter} from './sidenavAuditoria/auditoria-empresa-sidenav.filter';
import {AuditoriaEmpresaSuspensaoSidenavFilter} from './sidenavAuditoria/auditoria-empresa-suspensao-sidenav.filter';
import {EmpresaContratanteSidenavFilter} from './sidenavEmpresa/empresa-contratante-sidenav.filter';
import {EmpresaIncentivadaSidenavFilter} from './sidenavEmpresa/empresa-incentivada-sidenav.filter';
import {EmpresaPadisSidenavFilter} from './sidenavEmpresa/empresa-padis-sidenav.filter';
import {IndicadoResponsavelRdaSidenavFilter} from './sidenavEmpresa/indicado-responsavel-rda-sidenav.filter';
import {FiscalizacaoSidenavFilter} from './sidenavFiscalizacao/fiscalizacao-sidenav.filter';
import {InstituicaoSidenavFilter} from './sidenavInstituicao/instituicao-sidenav.filter';

export const sidenav = [
  FiscalizacaoSidenavFilter,
  EntidadeSelecionadaSidenavFilter,
  IndicadoResponsavelRdaSidenavFilter,
  InstituicaoSidenavFilter,
  EmpresaIncentivadaSidenavFilter,
  EmpresaPadisSidenavFilter,
  CartaCreditoSidenavFilter,
  RetificaCartaCreditoSidenavFilter,
  EmpresaContratanteSidenavFilter,
  AuditoriaEmpresaSidenavFilter,
  AuditoriaPadisSidenavFilter,
  AuditoriaEmpresaSuspensaoSidenavFilter
];
